import Paper from './Paper';
import Pay from './Pay';
import User from './User';
import Modals from './Modals';
import Admin from './Admin';
import AdminUser from './AdminUser';
import AdminUserCollection from './AdminUserCollection';
import AdminUserId from './AdminUserId';
import AdminDocument from './AdminDocument';
import CouponDetails from './CouponDetails';
import AffiliateDetails from './AffiliateDetails';

import Dashboard from './StudentDashboard';
import EditorDashboard from './EditorDashboard';
import FAQ from './FAQ';
import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';



const rootReducer = combineReducers({
    Paper: Paper,
    Modals: Modals,
    User: User,
    Pay: Pay,
    Admin: Admin,
    CouponDetails: CouponDetails,
    AffiliateDetails: AffiliateDetails,
    AdminUserCollection: AdminUserCollection,
    AdminUserId: AdminUserId,
    AdminDocument: AdminDocument,
    AdminUser: AdminUser,
    Dashboard: Dashboard,
    EditorDashboard: EditorDashboard,
    FAQ: FAQ,
    form : form
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js